
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mathmagic/esg",
      function () {
        return require("private-next-pages/mathmagic/esg.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mathmagic/esg"])
      });
    }
  